const SelectedChatsReadState = {
  allRead: 'allRead',
  someUnread: 'someUnread',
  none: 'none',
};

export default SelectedChatsReadState;
